import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Modal, FormSelect, FormControl } from "react-bootstrap";

import "./PurchaseSuccess.css";
import { playSound, handleClickSound } from "../../game/scenes/classes/PlaySound";

import chipz_1 from "../../../assets/images/chipz_1.png";
import chipz_2 from "../../../assets/images/chipz_2.png";
import chipz_3 from "../../../assets/images/chipz_3.png";
import chipz_4 from "../../../assets/images/chipz_4.png";

const chipzImages = { 1: chipz_1, 2: chipz_2, 3: chipz_3, 4: chipz_4 };
const chipzAmount = { 1: "100,000", 2: "500,000", 3: "1,000,000", 4: "5,000,000"};
const chipzFree = { 1: "0", 2: "25,000", 3: "70,000", 4: "500,000"};
const chipzTotal = { 1: "100,000", 2: "525,000", 3: "1,070,000", 4: "5,500,000"}

// Conversion values mapping - matches the purchase amounts
const conversionValueMap = {
    1: 0.99,
    2: 4.99,
    3: 9.99,
    4: 49.99
};

export default function CreateSuccessModal(props) {
    const navigate = useNavigate();

    // Function to generate unique transaction ID
    const generateTransactionId = () => {
        return `chipz_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    };

    // Function to track Google Ads conversion via GTM dataLayer
    const trackConversion = async (packageIndex) => {
        try {
            const value = conversionValueMap[packageIndex];
            const transactionId = generateTransactionId();

            if (value) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'purchase_success',
                    'conversionValue': value,
                    'currency': 'USD',
                    'transactionId': transactionId
                });
                console.log(`Conversion tracked: Package ${packageIndex}, Value: $${value}, Transaction ID: ${transactionId}`);
            }
        } catch (error) {
            console.error('Error tracking conversion:', error);
        }
    };

    // Track conversion when component mounts
    useEffect(() => {
        if (props.successPackage) {
            trackConversion(props.successPackage);
        }
    }, [props.successPackage]);

    const handleCloseModal = () => {
        props.setShowSuccessModal(false);
        navigate('/bonez'); // reset URL
    }

    const imageUrl = chipzImages[props.successPackage];
    const amount = chipzAmount[props.successPackage];
    const free = chipzFree[props.successPackage];
    const total = chipzTotal[props.successPackage];

    return (
        <Modal show={props.showSuccessModal} onHide={() => handleCloseModal } centered>
            <img className="chipzImage" src={imageUrl} alt={`chipz_${props.successPackage}`} style={{ position: "absolute", left: "60%", transform: "translateX(-50%)" }}/>
            <div className="whole-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '120%'}}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "5%" }}> 
                    <img
                        className="icon"
                        title="Zoombies Chipz"
                        src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                        style={{ width: "6%", marginRight: "2%" }}
                        alt="Chipz icon"
                    />
                    <span
                        className="container-body-text"
                        style={{ fontSize: "25px", color: "#FFFFFF", display: "block" }}
                    >
                        {amount}&nbsp;
                    </span>
                    <span
                        className="container-body-text"
                        style={{ fontSize: "25px", color: "#DC78FF" }}
                    >
                        {parseInt(free) > 0 ? "+ "+free+" FREE" : "+ No bonus"}
                    </span>
                    <span
                        className="container-body-text"
                        style={{ fontSize: "45px", color: "#FFFFFF", marginLeft: "2%", marginRight: "2%", marginBottom: "1%" }}
                    >
                        =
                    </span>
                    <img
                        className="icon"
                        title="Zoombies Chipz"
                        src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                        style={{ width: "6%", marginRight: "2%" }}
                        alt="Chipz icon"
                    />
                    <span
                        className="container-body-text"
                        style={{ fontSize: "40px", color: "#FFFFFF", display: "block" }}
                    >
                        {total}
                    </span>
                </div>
                <span
                    className="container-body-text"
                    style={{ fontSize: "45px", color: "#00D1FF" }}
                >
                    Purchase Successful!
                </span>
                <span
                    className="container-body-text"
                    style={{ fontSize: "30px", color: "#FFC350" }}
                >
                    Your Chipz will be credited to your account.
                </span>
                <span
                    className="container-body-text"
                    style={{ fontSize: "20px", color: "#FFFFFF", marginBottom: '3%' }}
                >
                    Make take up to 15 minutes to reflect in your balance.<br/>
                    A payment will appear on your statement.
                </span>
                <button
                    className={'button create-game-button'}
                    onClick={(e) => {
                        playSound("clickSound");
                        handleCloseModal();
                    }}
                >
                    <audio id="clickSound" className="sound-fx" hidden>
                        <source src="/bonez/sounds/click.mp3" type="audio/mp3"/>
                        Your browser does not support the audio element.
                    </audio>
                    <img
                        src="https://zoombies.world/images/dapp/green_button_400.webp"
                        alt=""
                        style={{ width: "100%", height: "100%" }}
                    />
                    <span
                        className="button-text"
                        style={{ color: "#000000" }}
                    >
                        OK
                    </span>
                </button>
                <span
                    className="container-body-text"
                    style={{ fontSize: "14px", color: "#00D1FF", marginTop: '3%' }}
                >
                    Questions regarding your purchase?&nbsp; 
                    <a
                        href="https://www.zoombies.info/support"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#00D1FF", textDecoration: "underline"}}
                    >
                        Click here for support.
                    </a>
                </span>
              </div>
        </Modal>
    )
}